import { WebsiteLink } from 'client/components/core/Sidebar/components/Settings/components/website-link'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities/index'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import React from 'react'
import { usePreserveEntityFieldsAcrossDiscriminator } from 'src/editor/hooks/use-preserve-fields-across-discriminator/use-preserve-entity-fields-across-discriminator'
import { ButtonLinkActionSettingsLayout } from 'src/editor/shared/settings/button/button-link-action-settings-layout'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { WebsiteLinkActionButtonEntityInterface } from 'src/shared/entities/button/website-link.action-button.schema'

export const ButtonWebsiteLinkActionSettings = ({
  entity,
}: SettingsProps<ActionButtonEntityInterface>) => {
  const updateProp = useUpdateProp(
    entity as WebsiteLinkActionButtonEntityInterface,
  )

  usePreserveEntityFieldsAcrossDiscriminator({
    entity: entity as WebsiteLinkActionButtonEntityInterface,
    discriminator: [
      { key: 'action', value: ButtonActionTypeEnum.WebsitePageLink },
    ],
    preservedKeys: ['websiteLink', 'linkTarget', 'rel'],
  })

  return entity.action === ButtonActionTypeEnum.WebsitePageLink ? (
    <ButtonLinkActionSettingsLayout entity={entity}>
      <WebsiteLink
        link={entity.websiteLink}
        update={updateProp('websiteLink')}
        withoutWrapper={false}
        labelText="entity_settings.button.website_links.label"
      />
    </ButtonLinkActionSettingsLayout>
  ) : null
}
